export const languages = {
  "en-US": ["English (Intermediate)"],
  "pt-BR": ["Inglês (Intermediário)"],
  "es-ES": ["Inglés (Intermedio)"],
}
